/**
 * Константи шляхів маршрутів додатку
 * Централізоване управління всіма URL для кращої підтримки та типобезпеки
 * @file routes.ts
 * @path frontend/src/constants/routes.ts
 */

/**
 * Об'єкт з усіма публічними маршрутами додатку
 * Маршрути, доступні без аутентифікації
 */
export const PUBLIC_ROUTES = Object.freeze({
  // Головна публічна сторінка
  HOME: "/",
  PUBLIC_SALONS: "/salons-list",

  // Аутентифікація
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  NEW_PASSWORD: "/new-password",

  // Сторінки зворотного зв'язку та інформаційні
  USER_FEEDBACK: "/s",
  AGREEMENT: "/user-agreement",
  PRIVACY_POLICY: "/privacy-policy",
  PUBLIC_OFFER: "/public-offer",
  ONLINE_SERVICE_BOOK: "/online-service-book",
  ONLINE_SERVICE_BOOK_WITH_HASH: "/online-service-book/:hash",

  // Платежі
  PAYMENT_SUCCESS: "/payment/success",

  // Сторінки помилок
  EXCEPTION: "/exception",
  EXCEPTION_STATUS_CODE: "/exception/:statusCode",
} as const);

/**
 * Об'єкт з усіма приватним маршрутами додатку
 * Маршрути, що вимагають аутентифікації
 */
export const PRIVATE_ROUTES = Object.freeze({
  // Головне меню та профіль
  HOME: "/home", // Головна сторінка для всіх користувачів
  MAIN_MENU: "/main-menu",
  PROFILE: "/profile",

  // Налаштування
  SETTINGS: "/settings",
  SETTINGS_SCHEDULE: "/settings/schedule",
  SETTINGS_WORKDAYS: "/settings/workdays",
  SETTINGS_BUSINESS: "/settings/business",
  SETTINGS_CUSTOMIZATION: "/settings/customization",
  SETTINGS_SITE: "/settings/site",
  SETTINGS_CATEGORIES: "/settings/categories",
  SETTINGS_PACKAGES: "/settings/packages",
  SETTINGS_CURRENCY: "/settings/currency",

  // Панель керування
  DASHBOARD: "/dashboard",

  // Клієнтське меню
  MY_RECORDS: "/my-records",
  VISIT_HISTORY: "/visit-history",
  FAVORITE_MASTERS: "/favorite-masters",
  REVIEWS: "/reviews",
  SUBSCRIPTION: "/client/subscription",
  SUPPORT: "/support",

  // Майстерське меню
  FINANCES: "/finances",
  STATISTICS: "/statistics",
  MASTER_SUBSCRIPTION: "/master/subscription",
  OWNER_SUBSCRIPTION: "/owner/subscription",
  APPOINTMENTS_TODAY: "/appointments/today",
  APPOINTMENTS_CALENDAR: "/appointments/calendar",

  // Завдання
  MY_TASKS: "/mytasks",
  MY_TASK_DETAILS: "/mytasks/:id",

  // Документи
  NEW_DOCUMENT: "/new-document",

  // Робочі області
  SPARE_PARTS_WORKPLACE: "/spare-parts-workplace",

  // Салон краси (специфічні маршрути)
  SALONS: "/salons",
  SALON_DETAILS: "/salons/:id",
  APPOINTMENTS: "/appointments",
  APPOINTMENTS_UPCOMING: "/appointments/upcoming",
  APPOINTMENTS_PAST: "/appointments/past",
  NEW_APPOINTMENT: "/appointments/new",
  MASTER_SCHEDULE: "/master/schedule",
  MASTER_CLIENTS: "/master/clients",
  CLIENTS: "/clients",
  SERVICES: "/services",
  STAFF: "/staff",

  // Адміністративні маршрути
  ADMIN_USERS: "/admin/users",
  ADMIN_BUSINESSES: "/admin/businesses",
  ADMIN_CLIENTS: "/admin/clients",
  ADMIN_SUBSCRIPTIONS: "/admin/subscriptions",
  ADMIN_SUPPORT: "/admin/support",
  ADMIN_CITIES: "/admin/cities",
  ADMIN_CLEAR: "/admin/clear",
  ADMIN_SETTINGS: "/admin/settings",
  ADMIN_ANALYTICS: "/admin/analytics",

  // Шинний сервіс (спеціальні маршрути)
  TIRE_FITTING: "/tire-fitting",
  SALON_SERVICES: "/salon-services",
  TIRE_APPOINTMENTS: "/tire-appointments",
  TIRE_INVENTORY: "/tire-inventory",

  // Автосервіс
  AUTO_SERVICES: "/auto-services",
  AUTO_APPOINTMENTS: "/auto-appointments",

  // SPA центр
  SPA_SERVICES: "/spa-services",
  SPA_APPOINTMENTS: "/spa-appointments",
} as const);

// ... (решта коду залишається без змін)
